import React, { useEffect, useState } from "react";
import { PrimaryBlueButton } from "@velaro/velaro-component-lib";
import useApi from "@/hooks/useApi";

interface FormstackConfig {
  displayName: string;
  token: string;
}

export default function FormstackCreate() {
  const [token, setToken] = useState("");
  const [displayName, setDisplayName] = useState("");
  //const maxLength = 108;
  const [config, setConfig] = React.useState<FormstackConfig>({
    displayName: "",
    token: ""
  });
  const api = useApi();

  const fetchConfig = React.useCallback(async () => {
    const response = await api.messaging.get(
      `Formstack/Integrations/GetConfig`
    );
    if (response.ok) {
      const text = await response.text();
      if (text) {
        const data = JSON.parse(text);
        setConfig(data);
      } else {
        setConfig({ displayName: "", token: "" });
      }
    } else {
      setConfig({ displayName: "", token: "" });
    }
  }, [api.messaging]);

  React.useEffect(() => {
    fetchConfig();
  }, [fetchConfig]);

  async function handleSubmit(config: FormstackConfig) {
    const response = await api.messaging.post(
      "Formstack/Integrations/SaveConfig",
      {
        displayName: config.displayName,
        token: config.token
      }
    );
    if (response.ok) {
      setConfig(config);
      window.location.href = `/integrations/formstack`;
    }
  }

  const isBtnActive = displayName && token;

  const saveBtnClass = !isBtnActive
    ? "bg-slate-300 border-slate-300 hover:bg-slate-300 hover:border-slate-500 text-white cursor-not-allowed"
    : "";

  return (
    <div className="panel bg-white dark:bg-stone-300 rounded-2xl shadow-md mb-4 p-6">
      <div className="w-full justify-between items-center inline-flex">
        <div className="w-full rounded-lg justify-between items-center gap-2 flex">
          <div className="text-center text-slate-500 text-sm font-medium flex"></div>
          <PrimaryBlueButton
            label="Save"
            onClick={async () => {
              await handleSubmit({ displayName, token });
            }}
            className={saveBtnClass}
          />
        </div>
      </div>

      <div className="w-1/3 place-self-center">
        <div className="w-full py-8 flex-col gap-6 inline-flex">
          <div className="text-center text-slate-900 text-xl font-medium">
            Formstack Configuration
          </div>

          <div className="flex flex-col gap-1">
            <label className="text-slate-800 text-sm font-medium">
              Display Name
            </label>
            <input
              type="text"
              className="px-4 py-2 bg-white rounded-lg border border-slate-300"
              value={displayName}
              placeholder="Enter display name"
              onChange={(e) => setDisplayName(e.target.value)}
            />
          </div>

          <div className="flex flex-col gap-1">
            <label className="text-slate-800 text-sm font-medium">
              Formstack Access Token
            </label>
            <input
              type="text"
              className={`px-4 py-2 bg-white rounded-lg border transition-colors duration-200 "border-red-500 focus:border-red-500"`}
              value={token}
              placeholder="Enter token"
              //maxLength={maxLength}
              onChange={(e) => setToken(e.target.value)}
            />

            {/* in case need to put maxlenght */}
            {/* <div className="text-xs text-right">
              {token.length > 0 && token.length !== maxLength && (
                <span className="text-red-500 ml-2">Invalid token. </span>
              )}
              <span
                className={
                  token.length > 0 && token.length !== maxLength
                    ? "text-red-500"
                    : "text-slate-500"
                }
              >
                {token.length}/{maxLength}
              </span>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
}
